import { getLocalizedMessage, showMessageAlert } from '@/core/shared'
import '@/core/plugins/bootstrap-treeview'

export function ExportManager () {
	this.itemIdsJson = {}
	this.exportConfigId = 0
	this.exportProgress = null
	this.exportsHistory = []

	this.setItemIdsJson = function (itemIds) {
		this.itemIdsJson = JSON.stringify(itemIds)
	}

	this.setExportConfigId = function (exportConfig) {
		this.exportConfigId = exportConfig
	}

	this.setExportProgress = function (progress) {
		this.exportProgress = progress
	}

	this.setExportsHistory = function (history) {
		this.exportsHistory = history
	}

	this.checkAllExportSuccess = function (callback) {
		var exportManager = this
		var oldCount = _.where(this.exportsHistory, { status: null }).length
		if (oldCount > 0) {
			var intervalId = setInterval(function () {
				exportManager.loadExportsHistory()
				var newCount = _.where(exportManager.exportsHistory, { status: null }).length
				if (oldCount != newCount) {
					callback(exportManager.exportsHistory)
					oldCount = newCount
				}
				if (newCount == 0) {
					clearInterval(intervalId)
				}
			}, 5000)
		}
	}

	this.loadExportsHistory = function () {
		$.ajax({
			url: window.urlContext + 'export',
			type: 'GET',
			async: false,
			context: this,
			success: function (data) {
				this.setExportsHistory(data)
			}
		})
	}

	this.checkExportStatus = function (exportUri) {
		$.ajax({
			url: exportUri,
			type: 'GET',
			async: false,
			context: this,
			success: function (data) {
				if (data['status'] == true) {
					this.setExportProgress(true)
				}
				if (data['status'] == false) {
					this.setExportProgress(false)
				}
			}
		})
	}

	this.createAsyncExport = function () {
		exportLauncher.launched = true
		$.ajax({
			url: window.urlContext + 'export',
			type: 'POST',
			async: true,
			context: this,
			data: {
				itemIdsJson: this.itemIdsJson,
				exportConfigId: this.exportConfigId
			},
			success: function (data) {
				var exportManager = this
				var newExportUri = 'export/' + data['id']
				var intervalId = setInterval(function () {
					exportManager.checkExportStatus(window.urlContext + newExportUri)
					if (exportManager.exportProgress == true) {
						downloadManager('/' + newExportUri + '/result')
						$('#exportProgress').remove()
						clearInterval(intervalId)
					}
					if (exportManager.exportProgress == false) {
						showMessageAlert(getLocalizedMessage('error'), getLocalizedMessage('export.error'), 'danger')
						$('#exportProgress').remove()
						clearInterval(intervalId)
					}
				}, 1000)
				exportLauncher.launched = false
			},
			error: function (error) {
				showMessageAlert(getLocalizedMessage('error'), 'danger')
				$('#exportProgress').remove()
				console.log(error)
				exportLauncher.launched = false
			}
		})
	}

	this.createSyncExport = function () {
		$.ajax({
			url: window.urlContext + 'export',
			type: 'POST',
			async: false,
			context: this,
			data: {
				itemIdsJson: this.itemIdsJson,
				exportConfigId: this.exportConfigId
			},
			success: function (data) {
				var exportManager = this
				var newExportUri = 'export/' + data['id']
				var intervalId = setInterval(function () {

					exportManager.checkExportStatus(window.urlContext + newExportUri)
					if (exportManager.exportProgress == true) {
						downloadManager('/' + newExportUri + '/result')
						clearInterval(intervalId)
					}
					if (exportManager.exportProgress == false) {
						showMessageAlert(getLocalizedMessage('error'), getLocalizedMessage('export.error'), 'danger')
						clearInterval(intervalId)
					}
					$('#sidebar_export').removeClass().addClass('fa fa-external-link')
				}, 1000)
			},
			error: function (error) {
				showMessageAlert(getLocalizedMessage('error'), 'danger')
				console.log(error)
				$('#exportProgress').remove()
			}
		})
	}
}

export var exportLauncher = (function () {

	function launch (itemIds, configId, target) {

		if (!checkExportParam(itemIds, configId)) {
			return false
		}

		var newExport = new ExportManager()

		newExport.setExportConfigId(configId)
		newExport.setItemIdsJson(itemIds)

		if (target != 'table') {
			showSyncExportProgress()
			newExport.createSyncExport()
		} else {
			showAsyncExportProgress()
			newExport.createAsyncExport()
		}
	}

	return {
		launchExport: function (itemIds, configId, target) {
			if (!this.launched) {
				launch(itemIds, configId, target)
			}
		}
	}

}())

function checkExportParam (itemIds, configId) {
	if (itemIds == []) {
		return false
	}

	if ((configId <= 0) || (configId > 2147483647)) {
		return false
	}

	return true
}

export function getExportReport (id, status) {
	$.ajax({
		url: window.urlContext + 'export/report/get',
		type: 'POST',
		data: { exportId: id },
		success: function (data) {
			if (status) {
				Swal.fire({
					title: getLocalizedMessage('success'),
					html: data,
					icon: 'success',
					showCancelButton: true,
					cancelButtonText: getLocalizedMessage('cancel'),
					buttonsStyling: false,
					allowEnterKey: true,
					showClass: {
						popup: ''
					},
					hideClass: {
						popup: ''
					},
					customClass: {
						confirmButton: 'uk-button uk-button-primary uk-button-small uk-margin-small-right',
						cancelButton: 'uk-button uk-button-default uk-button-small',
					}
				})
			} else {
				Swal.fire({
					title: getLocalizedMessage('error'),
					html: data,
					icon: 'error',
					showCancelButton: true,
					cancelButtonText: getLocalizedMessage('cancel'),
					buttonsStyling: false,
					allowEnterKey: true,
					showClass: {
						popup: ''
					},
					hideClass: {
						popup: ''
					},
					customClass: {
						confirmButton: 'uk-button uk-button-primary uk-button-small uk-margin-small-right',
						cancelButton: 'uk-button uk-button-default uk-button-small',
					}
				})
			}
		},
		error: function (data) {
			showMessageAlert(getLocalizedMessage('error'), data.statusText, 'danger')
		}
	})
}

function downloadExportResult (exportUri) {
	location.href = exportUri
}

function showSyncExportProgress () {
	$('#sidebar_export').removeClass().addClass('fa fa-refresh fa-spin')
}

function showAsyncExportProgress () {
	if (!$('#table-export').prev().hasClass('table_export-progress')) {
		$('#table-export').append('<span id=\'exportProgress\' class=\'table_export-progress loading fa fa-refresh fa-spin\'></span>')
	}
}

function initExportForm (configs, tags) {
	var tagsMap = new Map()
	_.each(tags, function (tag) {
		tagsMap.set(tag.id, tag)
	})

	var configByTagIdByConfigTypeMap = new Map()
	_.each(configs, function (config) {
		if (!configByTagIdByConfigTypeMap.has(config.type)) {
			configByTagIdByConfigTypeMap.set(config.type, new Map())
		}
		var configByTagIdMap = configByTagIdByConfigTypeMap.get(config.type)

		var tagId = tagsMap.has(config.tagId) ? config.tagId : null
		if (!configByTagIdMap.has(tagId)) {
			configByTagIdMap.set(tagId, [])
		}
		var configList = configByTagIdMap.get(tagId)

		configList.push(config)
	})

	var exportTypesList = $('#export-types-list')
	var exportTemplatesList = $('#export-templates-list')

	window.resetSearch = function (type) {
		var tree = $('#' + type)
		$('#search_' + type).val('')
		$('#search_output_' + type).treeview(true).remove()
		$('.list-group').show()
		tree.treeview(true).clearSearch()
		tree.treeview(true).collapseAll()
	}

	var configTypes = Array.from(configByTagIdByConfigTypeMap.keys()).sort()
	_.each(configTypes, function (type) {
		var configByTagIdMap = configByTagIdByConfigTypeMap.get(type)

		var tags = []
		_.each(Array.from(configByTagIdMap.keys()), function (tagId) {
			tags.push(tagsMap.has(tagId) ? tagsMap.get(tagId) : null)
		})
		tags.sort(function (first, second) {
			if (first == null) {
				return 1
			} else if (second == null) {
				return -1
			} else if (first.name < second.name) {
				return -1
			} else if (first.name > second.name) {
				return 1
			}
			return 0
		})

		_.each(tags, function (tag) {
			var configList = configByTagIdMap.get(tag == null ? null : tag.id)
			configList.sort(function (first, second) {
				if (first.name < second.name) {
					return -1
				} else if (first.name > second.name) {
					return 1
				}
				return 0
			})
		})

		exportTypesList.append('<li><a href=\'#tab_' + type + '\' data-toggle=\'tab\' tabindex=\'-1\'>' + type + '</a></li>')
		exportTemplatesList.append('<div class=\'tab-pane\' id=\'tab_' + type + '\'><input type=\'text\' class=\'textInput export-search\' id=\'search_' + type + '\' placeholder=\'' + getLocalizedMessage('search') + '\'><button onClick=resetSearch("'+ type +'") class="search_reset fa fa-times" tabindex="-1"></button><div id=\'search_output_' + type + '\'></div><div id=\'' + type + '\'><ul></ul></div></div>')
		$('#' + type).treeview({ data: getTreeView(configByTagIdMap, tags, type) })

		$('#search_' + type).on('keyup', function () {
			var value = $(this).val()

			var result = $('#' + type).treeview('search', [value, {
				ignoreCase: true,     // case insensitive
				exactMatch: false,    // like or equals
				revealResults: true,  // reveal matching nodes
			}])

			if (result.length !== 0) {
				$('#tab_' + type).find('.list-group').hide()
				var tree = []
				$.each(result, function (index, result) {
					var configTreeValue = new SimpleTree()
					configTreeValue.text = result.text
					tree.push(configTreeValue)
				})
				$('#search_output_' + type).treeview({ data: tree })
			} else {
				$('#search_output_' + type).treeview(true).remove()
				$('#tab_' + type).find('.list-group').show()
				$('#' + type).treeview(true).collapseAll()
			}
		})
	})

	$('.export-types a[data-toggle="tab"]').on('shown.bs.tab', function () {
		var tabId = $(this)[0].hash
		$(tabId).find('input').focus()
	})
}


function SimpleTree () {
	'use strict'
	this.text = ''

	this.setText = function (text) {
		this.text = text
	}
}

function State () {
	'use strict'
	this.expanded = false
}

function Tree () {
	'use strict'
	this.text = ''
	this.nodes = []
	this.state = new State()

	this.setText = function (text) {
		this.text = text
	}
}

function getTreeView (configByTagIdMap, tags, configType) {
	var data = []

	tags.forEach(function (tag) {
		var configList = configByTagIdMap.get(tag == null ? null : tag['id'])

		var tree = new Tree()
		if (tag == null) {
			tree.text = getLocalizedMessage('default.tag.name')
		} else {
			tree.text = tag['name']
			tree.hasTag = true
			tree.state.expanded = tag['open']
			tree.id = tag['id']
		}
		tree.selectable = false
		tree.configType = configType

		var trees = []
		_.each(configList, function (config) {
			var configTreeValue = new SimpleTree()
			configTreeValue.text = '<a data-config-id=\'' + config.id + '\'>' + config.name + '</a>'
			trees.push(configTreeValue)
		})
		tree.nodes = trees
		data.push(tree)
	})
	return data
}

export function bindExportFormAction (itemId, mode) {
	var onNodeClick = function (event, data) {
		var exportLink = $($.parseHTML(data.text))
		var exportConfigId = exportLink.attr('data-config-id')
		if (exportConfigId !== undefined) {
			$('#export-form').modal('hide')
			exportLauncher.launchExport([itemId], exportConfigId, mode)
		}
	}

	$('#export-templates-list').on('nodeSelected', onNodeClick)
	$('#export-templates-list').on('nodeUnselected', onNodeClick)
}

export function configureExport () {
	var configs
	var tags

	$.when(
		$.ajax({
			type: 'GET',
			url: window.urlContext + 'export-config',

			success: function (result) {
				configs = result
			}
		}),
		$.ajax({
			type: 'GET',
			url: window.urlContext + 'tags',

			success: function (result) {
				tags = result
			}
		})
	).then(function () {
		initExportForm(configs, tags);
	});
}
